import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import SearchBar from "@saleor/components/SearchBar";
import { sectionNames } from "@saleor/intl";
import { ShipmentList_shipments_edges_node } from "@saleor/shipment/types/ShipmentList";
import { shipmentListUrlSortField } from "@saleor/shipment/urls";
import {
  ListActions,
  PageListProps,
  SearchPageProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import Shipments from "../ShipmentList/ShipmentList";

export interface ShipmentListPageProps
  extends PageListProps,
    SearchPageProps,
    ListActions,
    SortPage<shipmentListUrlSortField>,
    TabPageProps {
  shipment: ShipmentList_shipments_edges_node[];
}

const ShipmentListPage: React.FC<ShipmentListPageProps> = ({
  initialSearch,
  onAdd,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  ...listProps
}) => {
  const intl = useIntl();

  return (
    <Container>
      <PageHeader
        title={intl.formatMessage(sectionNames.shipment)}
      ></PageHeader>
      <Card>
        <SearchBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Shipments",
            description: "tab name"
          })}
          currentTab={currentTab}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Collection"
          })}
          tabs={tabs}
          onAll={onAll}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <Shipments {...listProps} />
      </Card>
    </Container>
  );
};

export default ShipmentListPage;
